import React from "react";
import { TurnrTableCell, TurnrTableDropdownCell } from "../TurnrTableSmart.jsx";
import { UserAvatarCircleOnly, UserAvatarFullInfo } from "../../userAvatar/UserAvatar.jsx";
import { TurnrModalContainer, TurnrModalContent } from "../../modals/TurnrModal.jsx";
import { getUserDisplayFirstName } from "~/cores/userCore";

export function getTableHeadUser(props) {
    return {
        id: "userId",
        label: "User",
        hide: "",
        sortable: false,
        ...props,
    };
}

export function TableCellUser({ appProps, entity, user = entity?.user, size = "medium", ...rest }) {
    if (!user) {
        return <TurnrTableCell {...rest} />;
    }

    return (
        <TurnrTableDropdownCell
            {...rest}
            tight={true}
            dropdownContent={
                <TurnrModalContainer>
                    <TurnrModalContent size={"small"}>
                        <UserAvatarFullInfo user={user} />
                    </TurnrModalContent>
                </TurnrModalContainer>
            }
        >
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                {user && <UserAvatarCircleOnly user={user} size={size} />}
                {user && (
                    <div
                        className={"muted"}
                        style={{
                            fontSize: "11px",
                            maxWidth: "80px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                        }}
                    >
                        {getUserDisplayFirstName({ user })}
                    </div>
                )}
            </div>
        </TurnrTableDropdownCell>
    );
}
